import api from './api';

const fetchApiVersion = async () => {
  try {
    const { data } = await api.get(`/api-version`);

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

export default {
  fetchApiVersion,
};
